export default "__VITE_PUBLIC_ASSET__dcd83044__"